var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckGreenIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5003 17.6798C14.7419 17.6798 18.1803 14.2414 18.1803 9.99982C18.1803 5.75828 14.7419 2.31982 10.5003 2.31982C6.25876 2.31982 2.82031 5.75828 2.82031 9.99982C2.82031 14.2414 6.25876 17.6798 10.5003 17.6798ZM14.0591 8.75865C14.434 8.38374 14.434 7.77591 14.0591 7.401C13.6842 7.0261 13.0764 7.0261 12.7015 7.401L9.54031 10.5622L8.29913 9.321C7.92423 8.9461 7.31639 8.9461 6.94149 9.321C6.56659 9.69591 6.56659 10.3037 6.94149 10.6786L8.86149 12.5986C9.23639 12.9736 9.84423 12.9736 10.2191 12.5986L14.0591 8.75865Z",
    fill: "#17C964"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGreenIcon);
export default __webpack_public_path__ + "static/media/check-green-icon.c0e500d43822259d83da29cca1bfc2e8.svg";
export { ForwardRef as ReactComponent };